import * as $runtime from "../runtime.js";
import * as Control$dApplicative$dFree from "../Control.Applicative.Free/index.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Halogen$dData$dSlot from "../Halogen.Data.Slot/index.js";
import * as Halogen$dQuery$dChildQuery from "../Halogen.Query.ChildQuery/index.js";
const $HalogenF = (tag, _1, _2) => ({tag, _1, _2});
const identity = x => x;
const SubscriptionId = x => x;
const ForkId = x => x;
const State = value0 => $HalogenF("State", value0);
const Subscribe = value0 => value1 => $HalogenF("Subscribe", value0, value1);
const Unsubscribe = value0 => value1 => $HalogenF("Unsubscribe", value0, value1);
const Lift = value0 => $HalogenF("Lift", value0);
const ChildQuery = value0 => $HalogenF("ChildQuery", value0);
const Raise = value0 => value1 => $HalogenF("Raise", value0, value1);
const Par = value0 => $HalogenF("Par", value0);
const Fork = value0 => value1 => $HalogenF("Fork", value0, value1);
const Join = value0 => value1 => $HalogenF("Join", value0, value1);
const Kill = value0 => value1 => $HalogenF("Kill", value0, value1);
const GetRef = value0 => value1 => $HalogenF("GetRef", value0, value1);
const HalogenAp = x => x;
const HalogenM = x => x;
const unsubscribe = sid => Control$dMonad$dFree.$Free(
  Control$dMonad$dFree.$FreeView(
    "Bind",
    $HalogenF("Unsubscribe", sid, undefined),
    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
  ),
  Data$dCatList.CatNil
);
const subscribe$p = esc => Control$dMonad$dFree.$Free(
  Control$dMonad$dFree.$FreeView("Bind", $HalogenF("Subscribe", esc, v => {}), x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)),
  Data$dCatList.CatNil
);
const subscribe = es => Control$dMonad$dFree.$Free(
  Control$dMonad$dFree.$FreeView(
    "Bind",
    $HalogenF("Subscribe", v => es, identity),
    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
  ),
  Data$dCatList.CatNil
);
const semigroupHalogenM = dictSemigroup => Control$dMonad$dFree.semigroupFree(dictSemigroup);
const raise = o => Control$dMonad$dFree.$Free(
  Control$dMonad$dFree.$FreeView("Bind", $HalogenF("Raise", o, undefined), x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)),
  Data$dCatList.CatNil
);
const queryAll = () => dictIsSymbol => dictOrd => {
  const slots2 = Halogen$dData$dSlot.slots()(dictIsSymbol)(dictOrd);
  return label => q => {
    const go = (m$p, z$p) => {
      if (m$p.tag === "Leaf") { return z$p; }
      if (m$p.tag === "Node") {
        return go(
          m$p._5,
          (() => {
            const $0 = go(m$p._6, z$p);
            if (m$p._4.tag === "Nothing") { return $0; }
            if (m$p._4.tag === "Just") { return Data$dMap$dInternal.insert(dictOrd)(m$p._3)(m$p._4._1)($0); }
            $runtime.fail();
          })()
        );
      }
      $runtime.fail();
    };
    return Control$dMonad$dFree.$Free(
      Control$dMonad$dFree.$FreeView(
        "Bind",
        $HalogenF(
          "ChildQuery",
          Halogen$dQuery$dChildQuery.$ChildQuery(
            dictApplicative => {
              const traverse1 = Data$dMap$dInternal.traversableMap.traverse(dictApplicative);
              return k => {
                const $0 = dictApplicative.Apply0().Functor0().map(m => go(m, Data$dMap$dInternal.Leaf));
                const $1 = traverse1(k);
                const $2 = slots2(label);
                return x => $0($1($2(x)));
              };
            },
            q,
            identity
          )
        ),
        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
      ),
      Data$dCatList.CatNil
    );
  };
};
const query = () => dictIsSymbol => dictOrd => {
  const lookup2 = Halogen$dData$dSlot.lookup()(dictIsSymbol)(dictOrd);
  return label => p => q => Control$dMonad$dFree.$Free(
    Control$dMonad$dFree.$FreeView(
      "Bind",
      $HalogenF(
        "ChildQuery",
        Halogen$dQuery$dChildQuery.$ChildQuery(
          dictApplicative => k => {
            const $0 = dictApplicative.pure(Data$dMaybe.Nothing);
            const $1 = lookup2(label)(p);
            return x => {
              const $2 = $1(x);
              if ($2.tag === "Nothing") { return $0; }
              if ($2.tag === "Just") { return k($2._1); }
              $runtime.fail();
            };
          },
          q,
          identity
        )
      ),
      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
    ),
    Data$dCatList.CatNil
  );
};
const ordSubscriptionId = Data$dOrd.ordInt;
const ordForkId = Data$dOrd.ordInt;
const newtypeHalogenAp = {Coercible0: () => {}};
const monoidHalogenM = dictMonoid => Control$dMonad$dFree.monoidFree(dictMonoid);
const monadTransHalogenM = {
  lift: dictMonad => x => Control$dMonad$dFree.$Free(
    Control$dMonad$dFree.$FreeView("Bind", $HalogenF("Lift", x), x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)),
    Data$dCatList.CatNil
  )
};
const monadHalogenM = Control$dMonad$dFree.freeMonad;
const monadStateHalogenM = {
  state: x => Control$dMonad$dFree.$Free(
    Control$dMonad$dFree.$FreeView("Bind", $HalogenF("State", x), x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)),
    Data$dCatList.CatNil
  ),
  Monad0: () => Control$dMonad$dFree.freeMonad
};
const monadTellHalogenM = dictMonadTell => {
  const Semigroup0 = dictMonadTell.Semigroup0();
  return {
    tell: x => Control$dMonad$dFree.$Free(
      Control$dMonad$dFree.$FreeView(
        "Bind",
        $HalogenF("Lift", dictMonadTell.tell(x)),
        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
      ),
      Data$dCatList.CatNil
    ),
    Semigroup0: () => Semigroup0,
    Monad1: () => Control$dMonad$dFree.freeMonad
  };
};
const monadThrowHalogenM = dictMonadThrow => (
  {
    throwError: x => Control$dMonad$dFree.$Free(
      Control$dMonad$dFree.$FreeView(
        "Bind",
        $HalogenF("Lift", dictMonadThrow.throwError(x)),
        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
      ),
      Data$dCatList.CatNil
    ),
    Monad0: () => Control$dMonad$dFree.freeMonad
  }
);
const monadEffectHalogenM = dictMonadEffect => (
  {
    liftEffect: x => Control$dMonad$dFree.$Free(
      Control$dMonad$dFree.$FreeView(
        "Bind",
        $HalogenF("Lift", dictMonadEffect.liftEffect(x)),
        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
      ),
      Data$dCatList.CatNil
    ),
    Monad0: () => Control$dMonad$dFree.freeMonad
  }
);
const monadAskHalogenM = dictMonadAsk => (
  {
    ask: Control$dMonad$dFree.$Free(
      Control$dMonad$dFree.$FreeView(
        "Bind",
        $HalogenF("Lift", dictMonadAsk.ask),
        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
      ),
      Data$dCatList.CatNil
    ),
    Monad0: () => Control$dMonad$dFree.freeMonad
  }
);
const monadAffHalogenM = dictMonadAff => {
  const monadEffectHalogenM1 = monadEffectHalogenM(dictMonadAff.MonadEffect0());
  return {
    liftAff: x => Control$dMonad$dFree.$Free(
      Control$dMonad$dFree.$FreeView(
        "Bind",
        $HalogenF("Lift", dictMonadAff.liftAff(x)),
        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
      ),
      Data$dCatList.CatNil
    ),
    MonadEffect0: () => monadEffectHalogenM1
  };
};
const mapOutput = f => v => Control$dMonad$dFree.hoistFree(v1 => {
  if (v1.tag === "State") { return $HalogenF("State", v1._1); }
  if (v1.tag === "Subscribe") { return $HalogenF("Subscribe", v1._1, v1._2); }
  if (v1.tag === "Unsubscribe") { return $HalogenF("Unsubscribe", v1._1, v1._2); }
  if (v1.tag === "Lift") { return $HalogenF("Lift", v1._1); }
  if (v1.tag === "ChildQuery") { return $HalogenF("ChildQuery", v1._1); }
  if (v1.tag === "Raise") { return $HalogenF("Raise", f(v1._1), v1._2); }
  if (v1.tag === "Par") {
    return $HalogenF(
      "Par",
      (() => {
        const $0 = mapOutput(f);
        return Control$dApplicative$dFree.foldFreeAp(Control$dApplicative$dFree.applicativeFreeAp)(x => Control$dApplicative$dFree.$FreeAp("Lift", $0(x)))(v1._1);
      })()
    );
  }
  if (v1.tag === "Fork") { return $HalogenF("Fork", mapOutput(f)(v1._1), v1._2); }
  if (v1.tag === "Join") { return $HalogenF("Join", v1._1, v1._2); }
  if (v1.tag === "Kill") { return $HalogenF("Kill", v1._1, v1._2); }
  if (v1.tag === "GetRef") { return $HalogenF("GetRef", v1._1, v1._2); }
  $runtime.fail();
})(v);
const mapAction = dictFunctor => f => v => Control$dMonad$dFree.hoistFree(v1 => {
  if (v1.tag === "State") { return $HalogenF("State", v1._1); }
  if (v1.tag === "Subscribe") {
    return $HalogenF(
      "Subscribe",
      x => {
        const $0 = v1._1(x);
        return k => $0(x$1 => k(f(x$1)));
      },
      v1._2
    );
  }
  if (v1.tag === "Unsubscribe") { return $HalogenF("Unsubscribe", v1._1, v1._2); }
  if (v1.tag === "Lift") { return $HalogenF("Lift", v1._1); }
  if (v1.tag === "ChildQuery") { return $HalogenF("ChildQuery", v1._1); }
  if (v1.tag === "Raise") { return $HalogenF("Raise", v1._1, v1._2); }
  if (v1.tag === "Par") {
    return $HalogenF(
      "Par",
      (() => {
        const $0 = mapAction(dictFunctor)(f);
        return Control$dApplicative$dFree.foldFreeAp(Control$dApplicative$dFree.applicativeFreeAp)(x => Control$dApplicative$dFree.$FreeAp("Lift", $0(x)))(v1._1);
      })()
    );
  }
  if (v1.tag === "Fork") { return $HalogenF("Fork", mapAction(dictFunctor)(f)(v1._1), v1._2); }
  if (v1.tag === "Join") { return $HalogenF("Join", v1._1, v1._2); }
  if (v1.tag === "Kill") { return $HalogenF("Kill", v1._1, v1._2); }
  if (v1.tag === "GetRef") { return $HalogenF("GetRef", v1._1, v1._2); }
  $runtime.fail();
})(v);
const kill = fid => Control$dMonad$dFree.$Free(
  Control$dMonad$dFree.$FreeView("Bind", $HalogenF("Kill", fid, undefined), x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)),
  Data$dCatList.CatNil
);
const join = fid => Control$dMonad$dFree.$Free(
  Control$dMonad$dFree.$FreeView("Bind", $HalogenF("Join", fid, undefined), x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)),
  Data$dCatList.CatNil
);
const imapState = f => f$p => v => Control$dMonad$dFree.hoistFree(v1 => {
  if (v1.tag === "State") {
    return $HalogenF(
      "State",
      x => {
        const $0 = v1._1(f$p(x));
        return Data$dTuple.$Tuple($0._1, f($0._2));
      }
    );
  }
  if (v1.tag === "Subscribe") { return $HalogenF("Subscribe", v1._1, v1._2); }
  if (v1.tag === "Unsubscribe") { return $HalogenF("Unsubscribe", v1._1, v1._2); }
  if (v1.tag === "Lift") { return $HalogenF("Lift", v1._1); }
  if (v1.tag === "ChildQuery") { return $HalogenF("ChildQuery", v1._1); }
  if (v1.tag === "Raise") { return $HalogenF("Raise", v1._1, v1._2); }
  if (v1.tag === "Par") {
    return $HalogenF(
      "Par",
      (() => {
        const $0 = imapState(f)(f$p);
        return Control$dApplicative$dFree.foldFreeAp(Control$dApplicative$dFree.applicativeFreeAp)(x => Control$dApplicative$dFree.$FreeAp("Lift", $0(x)))(v1._1);
      })()
    );
  }
  if (v1.tag === "Fork") { return $HalogenF("Fork", imapState(f)(f$p)(v1._1), v1._2); }
  if (v1.tag === "Join") { return $HalogenF("Join", v1._1, v1._2); }
  if (v1.tag === "Kill") { return $HalogenF("Kill", v1._1, v1._2); }
  if (v1.tag === "GetRef") { return $HalogenF("GetRef", v1._1, v1._2); }
  $runtime.fail();
})(v);
const hoist = dictFunctor => nat => v => Control$dMonad$dFree.hoistFree(v1 => {
  if (v1.tag === "State") { return $HalogenF("State", v1._1); }
  if (v1.tag === "Subscribe") { return $HalogenF("Subscribe", v1._1, v1._2); }
  if (v1.tag === "Unsubscribe") { return $HalogenF("Unsubscribe", v1._1, v1._2); }
  if (v1.tag === "Lift") { return $HalogenF("Lift", nat(v1._1)); }
  if (v1.tag === "ChildQuery") { return $HalogenF("ChildQuery", v1._1); }
  if (v1.tag === "Raise") { return $HalogenF("Raise", v1._1, v1._2); }
  if (v1.tag === "Par") {
    return $HalogenF(
      "Par",
      (() => {
        const $0 = hoist(dictFunctor)(nat);
        return Control$dApplicative$dFree.foldFreeAp(Control$dApplicative$dFree.applicativeFreeAp)(x => Control$dApplicative$dFree.$FreeAp("Lift", $0(x)))(v1._1);
      })()
    );
  }
  if (v1.tag === "Fork") { return $HalogenF("Fork", hoist(dictFunctor)(nat)(v1._1), v1._2); }
  if (v1.tag === "Join") { return $HalogenF("Join", v1._1, v1._2); }
  if (v1.tag === "Kill") { return $HalogenF("Kill", v1._1, v1._2); }
  if (v1.tag === "GetRef") { return $HalogenF("GetRef", v1._1, v1._2); }
  $runtime.fail();
})(v);
const getRef = p => Control$dMonad$dFree.$Free(
  Control$dMonad$dFree.$FreeView("Bind", $HalogenF("GetRef", p, identity), x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)),
  Data$dCatList.CatNil
);
const functorHalogenM = Control$dMonad$dFree.freeFunctor;
const functorHalogenAp = Control$dApplicative$dFree.functorFreeAp;
const functorHalogenF = dictFunctor => (
  {
    map: f => v => {
      if (v.tag === "State") {
        return $HalogenF(
          "State",
          x => {
            const $0 = v._1(x);
            return Data$dTuple.$Tuple(f($0._1), $0._2);
          }
        );
      }
      if (v.tag === "Subscribe") { return $HalogenF("Subscribe", v._1, x => f(v._2(x))); }
      if (v.tag === "Unsubscribe") { return $HalogenF("Unsubscribe", v._1, f(v._2)); }
      if (v.tag === "Lift") { return $HalogenF("Lift", dictFunctor.map(f)(v._1)); }
      if (v.tag === "ChildQuery") {
        const $0 = v._1;
        return $HalogenF("ChildQuery", Halogen$dQuery$dChildQuery.$ChildQuery(dictApplicative => $0._1(dictApplicative), $0._2, x => f($0._3(x))));
      }
      if (v.tag === "Raise") { return $HalogenF("Raise", v._1, f(v._2)); }
      if (v.tag === "Par") { return $HalogenF("Par", Control$dApplicative$dFree.$FreeAp("Ap", Control$dApplicative$dFree.$FreeAp("Pure", f), v._1)); }
      if (v.tag === "Fork") { return $HalogenF("Fork", v._1, x => f(v._2(x))); }
      if (v.tag === "Join") { return $HalogenF("Join", v._1, f(v._2)); }
      if (v.tag === "Kill") { return $HalogenF("Kill", v._1, f(v._2)); }
      if (v.tag === "GetRef") { return $HalogenF("GetRef", v._1, x => f(v._2(x))); }
      $runtime.fail();
    }
  }
);
const fork = hmu => Control$dMonad$dFree.$Free(
  Control$dMonad$dFree.$FreeView("Bind", $HalogenF("Fork", hmu, identity), x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)),
  Data$dCatList.CatNil
);
const eqSubscriptionId = Data$dEq.eqInt;
const eqForkId = Data$dEq.eqInt;
const bindHalogenM = Control$dMonad$dFree.freeBind;
const applyHalogenM = Control$dMonad$dFree.freeApply;
const applyHalogenAp = Control$dApplicative$dFree.applyFreeAp;
const parallelHalogenM = {
  parallel: x => Control$dApplicative$dFree.$FreeAp("Lift", x),
  sequential: x => Control$dMonad$dFree.$Free(
    Control$dMonad$dFree.$FreeView("Bind", $HalogenF("Par", x), x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)),
    Data$dCatList.CatNil
  ),
  Apply0: () => Control$dMonad$dFree.freeApply,
  Apply1: () => Control$dApplicative$dFree.applyFreeAp
};
const applicativeHalogenM = Control$dMonad$dFree.freeApplicative;
const monadRecHalogenM = {
  tailRecM: k => a => {
    const $0 = k(a);
    const $1 = v => {
      if (v.tag === "Loop") { return monadRecHalogenM.tailRecM(k)(v._1); }
      if (v.tag === "Done") { return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._1), Data$dCatList.CatNil); }
      $runtime.fail();
    };
    return Control$dMonad$dFree.$Free(
      $0._1,
      (() => {
        if ($0._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
        if ($0._2.tag === "CatCons") {
          return Data$dCatList.$CatList(
            "CatCons",
            $0._2._1,
            Data$dCatQueue.$CatQueue(
              $0._2._2._1,
              Data$dList$dTypes.$List("Cons", Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)), $0._2._2._2)
            )
          );
        }
        $runtime.fail();
      })()
    );
  },
  Monad0: () => Control$dMonad$dFree.freeMonad
};
const applicativeHalogenAp = Control$dApplicative$dFree.applicativeFreeAp;
export {
  $HalogenF,
  ChildQuery,
  Fork,
  ForkId,
  GetRef,
  HalogenAp,
  HalogenM,
  Join,
  Kill,
  Lift,
  Par,
  Raise,
  State,
  Subscribe,
  SubscriptionId,
  Unsubscribe,
  applicativeHalogenAp,
  applicativeHalogenM,
  applyHalogenAp,
  applyHalogenM,
  bindHalogenM,
  eqForkId,
  eqSubscriptionId,
  fork,
  functorHalogenAp,
  functorHalogenF,
  functorHalogenM,
  getRef,
  hoist,
  identity,
  imapState,
  join,
  kill,
  mapAction,
  mapOutput,
  monadAffHalogenM,
  monadAskHalogenM,
  monadEffectHalogenM,
  monadHalogenM,
  monadRecHalogenM,
  monadStateHalogenM,
  monadTellHalogenM,
  monadThrowHalogenM,
  monadTransHalogenM,
  monoidHalogenM,
  newtypeHalogenAp,
  ordForkId,
  ordSubscriptionId,
  parallelHalogenM,
  query,
  queryAll,
  raise,
  semigroupHalogenM,
  subscribe,
  subscribe$p,
  unsubscribe
};
